import * as yup from 'yup';

import { getFileSchema } from '../../../common';

export const addProductSchemas = yup.object({
  // Listing props
  title: yup
    .string()
    .required('Title is required')
    .matches(
      /^[A-Za-z0-9._~ ]+$/,
      "Title should only contain AlphaNumeric characters, space and '.', '_', '~'"
    )
    .matches(/^\S.*\S$|^\S$/, 'Title sould not have traling spaces'),
  images: yup
    .array(getFileSchema(['image/']).required())
    .max(4)
    // .min(1, 'Image is required')
    .required('Image is required'),
  ageGroup: yup
    .object({
      from: yup.number().required().min(0),
      to: yup.number().required().min(yup.ref('from'), 'To Age must be greater than or equal to From Age')
    })
    .required(),

  // Venue Props

  shortAddress: yup
    .string()
    .max(200)
    .required('Short Venue Address is required')
    .matches(
      /^[A-Za-z0-9._~ ]+$/,
      "Title should only contain AlphaNumeric characters, space and '.', '_', '~'"
    )
    .matches(/^\S.*\S$|^\S$/, 'Title sould not have traling spaces'),
  address: yup.string().max(200).required('Venue Address is required'),
  phoneNumber: yup
    .string()
    .required('Phone number is required')
    .matches(/^[0-9]{10}$/, 'Phone number must be a 10-digit number without any special characters'),
  city: yup.string().required('City is required'),
  location: yup
    .string()
    .required('Venue Location is required')
    .matches(/^https?:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/, 'Location should be a valid link'),
  openDate: yup.object({
    from: yup.date().required('From Date is required'),
    to: yup
      .date()
      .required('To Date is required')
      .min(yup.ref('from'), 'To Date must be greater than or equal to From Date')
  }),
  openSlots: yup
    .array(
      yup.object({
        from: yup.date().required('From Time is required'),
        to: yup
          .date()
          .required('To Time is required')
          .min(yup.ref('from'), 'To Time must be greater than or equal to From Time')
      })
    )
    .max(3)
    .required('Open slots are required'),
  packages: yup
    .array(
      yup.object({
        id: yup.string().transform(value => (value === '' ? undefined : value)),
        title: yup.string().required('Package title is required'),
        duration: yup.number().required('Duration is required'),
        price: yup.number().required('Price is required'),
        discount: yup
          .number()
          .required('Discount % is required')
          .min(0, 'Discount should be greater than 0')
          .max(100, 'Discount should be less than 100'),

        resources: yup.object({
          count: yup.number(),
          details: yup
            .array(
              yup.object({
                id: yup.string().transform(value => (value === '' ? undefined : value)),
                name: yup.string().required('Resource name is required')
              })
            )
            .min(1)
            .required()
        })
      })
    )
    .min(1)
    .required('Service is Required')
});

export type AddProductsFormData = yup.InferType<typeof addProductSchemas>;
